import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AbsenceList from './AbsenceList';
import AbsenceCalendar from './AbsenceCalendar';

const Absence = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Paper sx={{ mb: 3, borderRadius: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
            },
          }}
        >
          <Tab label={t('absence.list')} />
          <Tab label={t('absence.calendar')} />
        </Tabs>
      </Paper>

      <Box>
        {activeTab === 0 && <AbsenceList />}
        {activeTab === 1 && <AbsenceCalendar />}
      </Box>
    </Box>
  );
};

export default Absence;
